import { ReconciliationOutlined } from "@ant-design/icons";

const StudioAdminHeader = () => {
  return (
    <h2 className="header-section-title">
      <ReconciliationOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>Studio</span>
    </h2>
  );
};

export default StudioAdminHeader;
